import { Checkbox } from '@rbilabs/components-library/build/components/checkbox';
import styled from 'styled-components';

export const StyledLink = styled.a`
  color: ${Styles.color.black};
  text-decoration: underline;
`;

export const Wrapper = styled.div`
  margin-top: 15px;
  width: 100%;
`;
export const DonationBox = styled.div<{ show: boolean }>`
  display: ${p => (p.show ? 'block' : 'none')};
  background: white;
  border-radius: 4px;
  padding: 8px;
`;

export const InfoIcon = styled.span`
  float: right;
  border-radius: 50px;
  cursor: pointer;
`;

export const DonationTopBox = styled.div`
  display: flex;
  padding: 5px;
`;

export const LogoBox = styled.div`
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  ${Styles.mobile`
    font-size:.85rem;
  `}
`;

export const LogoImageContainer = styled.div`
  flex: 1;
  & > div {
    overflow: none;
  }
  & > div > img {
    top: 0px;
    width: 90% !important;
    height: 90% !important;
  }
`;
export const TextHeader = styled.span`
  font-weight: bold;
  display: block;
`;

export const TextSubtitle = styled.span`
  display: block;
  ${Styles.desktop`
    font-size:.9rem;
  `}
  ${Styles.mobile`
    font-size:.8rem;
  `}
`;

export const HeadBox = styled.div`
  padding: 7px;
  width: 80%;
`;
export const ToggleWrapper = styled.div`
  fieldset {
    margin: 0;
  }
  legend {
    display: none;
  }
  div {
    width: 100%;
    > label {
      width: 100%;
      margin: 0;
      padding: 0px !important;
      ${Styles.desktop`
        font-size:.9rem;
      `}
      ${Styles.mobile`
        font-size:.8rem;
      `}
    }
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  flex-direction: row-reverse;
  display: flex;
  justify-content: space-between;
  width: 100%;
  > div:last-child {
    margin: 0;
  }
`;
